import { selector } from 'recoil';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { getCoverableById } from '../../utils/coverablesUtil';
import { opcInfoAtom } from '../atoms/opcInfoAtom';

interface OpcCoverableStatus {
    isAddedCoverable: boolean;
    isChangedCoverable: boolean;
}

export const opcCoverableStatusSelector = selector<OpcCoverableStatus>({
    key: 'opcCoverableStatusSelector',
    get: ({ get }) => {
        const { coverableId } = get(opcInfoAtom);
        const coverables = get(allCoverablesAtom);
        const coverable = getCoverableById(coverables, coverableId);
        if (!coverable) {
            return { isAddedCoverable: false, isChangedCoverable: false };
        }
        const { status } = coverable;
        return {
            isAddedCoverable: status === 'Added',
            isChangedCoverable: status === 'Changed'
        };
    }
});
